import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'index',
    component: ()=>import(/* webpackChunkName: "index" */ '../views/index.vue')
  },
  {
    path: '/culture',
    name: 'culture',
    component: () => import(/* webpackChunkName: "culture" */ '../views/culture.vue')
  },
  {
    path: '/staff',
    name: 'staff',
    component: () => import(/* webpackChunkName: "staff" */ '../views/staff.vue')
  },
  {
    path: '/headquarters',
    name: 'headquarters',
    component: () => import(/* webpackChunkName: "headquarters" */ '../views/headquarters.vue')
  },
  {
    path: '/tv',
    name: 'tv',
    component: () => import(/* webpackChunkName: "tv" */ '../views/tv.vue')
  },
  {
    path: '/newslist',
    name: 'newslist',
    component: () => import(/* webpackChunkName: "newslist" */ '../views/newslist.vue')
  },
  {
    path: '/newsdetail',
    name: 'newsdetail',
    component: () => import(/* webpackChunkName: "newsdetail" */ '../views/newsdetail.vue')
  },
  {
    path: '/kingdom',
    name: 'kingdom',
    component: () => import(/* webpackChunkName: "kingdom" */ '../views/kingdom.vue')
  },
  {
    path: '/enterpriser',
    name: 'enterpriser',
    component: () => import(/* webpackChunkName: "enterpriser" */ '../views/enterpriser.vue')
  },
  {
    path: '/chestnut',
    name: 'chestnut',
    component: () => import(/* webpackChunkName: "chestnut" */ '../views/chestnut.vue')
  },
  {
    path: '/store',
    name: 'store',
    component: () => import(/* webpackChunkName: "store" */ '../views/store.vue')
  },
  {
    path: '/employee',
    name: 'employee',
    component: () => import(/* webpackChunkName: "employee" */ '../views/employee.vue')
  },
  {
    path: '/themelist',
    name: 'themelist',
    component: () => import(/* webpackChunkName: "themelist" */ '../views/themelist.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "join" */ '../views/join.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to,from,next) => {
  console.log(to)
  window.scrollTo(0,0);
});
export default router
